<template>
	<LoginLayout
		heading="Session Expired"
	>
		<template #form>
			<div class="text-center session-text">
				<div class="login-icon-roundel mb-4">
					<v-icon size="32">
						mdi-clock-alert-outline
					</v-icon>
				</div>
				<p>
					We've logged you out
				</p>
				<p>
					To help keep your details secure, we automatically log you out after
					15 minutes of inactivity.
				</p>
				<p>
					Please <a
						href="/login"
						class="session-link"
						@click.prevent="redirectToLogin"
					>click here</a> to return to the
					login screen.
				</p>
			</div>
		</template>
	</LoginLayout>
</template>

<script>
import LoginLayout from '../../../../shared/layouts/login-layout.vue'

export default {
	components: {
		LoginLayout
	},
	methods: {
		redirectToLogin () {
			setTimeout(() => {
				this.$router.push('/login')
			}, 500) // 500ms delay
		}
	}
}
</script>

<style scoped>
.session-text {
	font-size: 14px;
	line-height: 1.5;
}
.session-text p {
	margin-bottom: 0.75em;
}
.session-link {
	cursor: pointer;
	text-decoration: none;
	font-weight: 500;
}
.session-link:hover {
	text-decoration: underline;
}
</style>
